import { render } from "./CustomerContacts.vue?vue&type=template&id=19c03b5f&ts=true"
import script from "./CustomerContacts.vue?vue&type=script&lang=ts"
export * from "./CustomerContacts.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__